import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoaderComponent } from './loader.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ManageBrokersComponent } from './components/manage-brokers/manage-brokers.component';
import { TabsComponent } from './components/tabs/tabs.component';
import { TooltipsComponent } from './components/tooltips/tooltips.component';
import { FooterComponent } from './layouts/footer/footer.component';
import { RxReactiveFormsModule } from '@rxweb/reactive-form-validators';
import { HeaderComponent } from './layouts/header/header.component';
import { SidebarComponent } from './layouts/sidebar/sidebar.component';
import { LoaderInterceptor } from './loader.interceptor';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { MangeClientsComponent } from './pages/mange-clients/mange-clients.component';
import { PagesLoginComponent } from './pages/pages-login/pages-login.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';
import { ToastrModule } from 'ngx-toastr';
import { ExcelService } from './services/excel.service';
import { EnableDisableDirective } from './Directives/enable-disable.directive';
import { PhoneMaskDirective } from './Directives/phone-mask.directive';
import { AddbrokerDetailsComponent } from './components/addbrokerDetails/addbrokerDetails.component';
import { ChartGuageComponent } from './components/chart-guage/chart-guage.component';
import { EmployeeComponent } from './components/employee/employee.component';
import { WalletConfigComponent } from './components/wallet-config/wallet-config.component';
// import { AddbrokerDetailsComponent } from './components/addbrokerDetails/addbrokerDetails.component'
import { EditAdvisorComponent } from './components/edit-advisor/edit-advisor.component';
import { ReportsComponent } from './components/reports/reports.component';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { DataTablesModule } from 'angular-datatables';
import { SignaturePadModule } from 'angular2-signaturepad';
import { RecaptchaFormsModule, RecaptchaModule } from 'ng-recaptcha';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { ClipboardModule } from 'ngx-clipboard';
import { SwiperModule } from 'swiper/angular';
import { AddCustomerComponent } from './components/add-customer/add-customer.component';
import { AddEmployeeComponent } from './components/add-employee/add-employee.component';
import { ConfirmationDialogComponent } from './components/confirmation-dialog/confirmation-dialog.component';
import { EditCorporateComponent } from './components/edit-corporate/edit-corporate.component';
import { EmployeePortalComponent } from './components/employee-portal/employee-portal.component';
import { InvoicesComponent } from './components/invoices/invoices.component';
import { ManageClientsComponent } from './components/manage-clients/manage-clients.component';
import { ManageCustomersComponent } from './components/manage-customers/manage-customers.component';
import { ManageSystemUsersComponent } from './components/manage-system-users/manage-system-users.component';
import { MarketingComponent } from './components/marketing/marketing.component';
import { MyplansComponent } from './components/myplans/myplans.component';
import { OverviewComponent } from './components/overview/overview.component';
import { PayablesComponent } from './components/payables/payables.component';
import { SettingsComponent } from './components/settings/settings.component';
import { ViewCustomerDetailsComponent } from './components/view-customer-details/view-customer-details.component';
import { ViewCustomersComponent } from './components/viewCustomers/viewCustomers.component';
import { FilerenamePipe } from './pipes/filerename.pipe';
import { PhoneFormatPipe } from './pipes/phone-format.pipe';
import { SalestrackingcodePipe } from './pipes/salestrackingcode.pipe';
import { AuthGuardService } from './services/authGuard.service';
// import { AddEmployeeComponent } from './add-employee/add-employee.component';
import { CacheService } from './services/cache.service';
import { CommonModule } from '@angular/common';
import { AdvisorDashboardComponent } from './components/advisor-dashboard/advisor-dashboard.component';
import { CorporateDashboardComponent } from './components/corporate-dashboard/corporate-dashboard.component';
import { CreateEmployeeComponent } from './components/create-employee/create-employee.component';
import { PlansDetailsComponent } from './components/plans-details/plans-details.component';
import { ParseHeadersPipe } from './pipes/parse-headers.pipe';
import { ParseValuesPipe } from './pipes/parse-values.pipe';
import { ApiService } from './services/api.service';
import { ReportService } from './services/report.service';
import { SocketService } from './services/socket.service';
import { TravelCommissionsComponent } from './components/travel-commissions/travel-commissions.component';
import { ReportsScheduleComponent } from './components/reports-schedule/reports-schedule.component';
import { TravelCommissionsService } from './services/travel-commissions.service';
import { ReportScheduleService } from './services/report-schedule.service';
import { PaymentPdsComponent } from './components/payment-pds/payment-pds.component';
import { CurrencyMaskModule } from 'ng2-currency-mask';
import { InvoiceDataComponent } from './components/invoice-data/invoice-data.component';
import { PaymentsComponent } from './components/payments/payments.component';
import { PaymentService } from './services/payment.service';
import { ManageCustomersNewComponent } from './components/manage-customers-new/manage-customers-new.component';
import { ManageBrokersNewComponent } from './components/manage-brokers-new/manage-brokers-new.component';
import { ManageClientsNewComponent } from './components/manage-clients-new/manage-clients-new.component';
import { ProvisioningComponent } from './components/provisioning/provisioning.component';
import { ManageCustomersDatatableComponent } from './components/manage-customers-datatable/manage-customers-datatable.component';
import { SocketMemberService } from './services/socket-member.service';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { QuillModule } from 'ngx-quill';
import { MemberEffects } from './state/effects/members.effects';
import { reducers } from '../app/state/reducers';
import { CorporateEffects } from './state/effects/corporates.effects';
import { memberReducer } from './state/reducers/members.reducers';
import { corporateReducer } from './state/reducers/corporates.reducers';
import { AdvisorEffects } from './state/effects/advisors.effects';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { BrouchersComponent } from './components/brouchers/brouchers.component';
import { LanguageEffects } from './state/effects/languageStrings.effects';
import { GigToCorpComponent } from './components/gig-to-corp/gig-to-corp.component';
import { BrokerConfigEffects } from './state/effects/brokerConfig.effects';
import { CorporateSignupConfigEffects } from './state/effects/corporateSignupConfig.effects';
import { TwodigitsDirective } from './Directives/twodigits.directive';
import { BrokerFormConfigEffects } from './state/effects/brokerFormConfig.effects';
import { PaymentComponent } from './payment/payment.component';
import { CapitalizeDirective } from './Directives/capitalize.directive';
import { FormConfig2Effects } from './state/effects/formConfig2.effect';
import { NumberFormatPipe } from './pipes/number-format.pipe';
import { TierWalletComponent } from './components/tier-wallet/tier-wallet.component';
import { AddTierComponent } from './components/add-tier/add-tier.component';
import { ProductCatalogComponent } from './pages/product-catalog/product-catalog.component';
import { TaxTablesComponent } from './pages/tax-tables/tax-tables.component';
import { SupplierComponent } from './pages/supplier/supplier.component';
import { CommonPlansComponent } from './app/common-plans/common-plans.component';
import { AdjudicationQueueComponent } from './components/adjudication-queue/adjudication-queue.component';
import { AddDependentComponent } from './components/add-dependent/add-dependent.component';
import { InvoiceModuleComponent } from './invoice-module/invoice-module.component';
import { CreateSupplierComponent } from './components/create-supplier/create-supplier.component';
import { NgxEditorModule } from 'ngx-editor';
import { ReceivablesComponent } from './receivables/receivables.component';
import { PayableComponent } from './payable/payable.component';
import { NgxDocViewerModule } from 'ngx-doc-viewer';
import { UpdateSupplierComponent } from './components/update-supplier/update-supplier.component';
import { EditSupplierProductComponent } from './edit-supplier-product/edit-supplier-product.component';


@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    SidebarComponent,
    DashboardComponent,
    OverviewComponent,
    PagesLoginComponent,
    TooltipsComponent,
    MangeClientsComponent,
    ManageBrokersComponent,
    ViewCustomersComponent,
    PhoneMaskDirective,
    EnableDisableDirective,
    ChartGuageComponent,
    EmployeeComponent,
    WalletConfigComponent,
    LoaderComponent,
    AddbrokerDetailsComponent,
    EditAdvisorComponent,
    ReportsComponent,
    EmployeePortalComponent,
    FilerenamePipe,
    MyplansComponent,
    ManageSystemUsersComponent,
    InvoicesComponent,
    PayablesComponent,
    MarketingComponent,
    SettingsComponent,
    ManageClientsComponent,
    ManageCustomersComponent,
    ViewCustomerDetailsComponent,
    PhoneFormatPipe,
    EditCorporateComponent,
    CreateEmployeeComponent,
    AddCustomerComponent,
    AddEmployeeComponent,
    SalestrackingcodePipe,
    ConfirmationDialogComponent,
    CorporateDashboardComponent,
    AdvisorDashboardComponent,
    PlansDetailsComponent,
    ParseHeadersPipe,
    ParseValuesPipe,
    TravelCommissionsComponent,
    ReportsScheduleComponent,
    PaymentPdsComponent,
    InvoiceDataComponent,
    PaymentsComponent,
    ManageCustomersNewComponent,
    ManageBrokersNewComponent,
    ManageClientsNewComponent,
    ProvisioningComponent,
    ManageCustomersDatatableComponent,
    BrouchersComponent,
    GigToCorpComponent,
    TwodigitsDirective,
    CapitalizeDirective,
    NumberFormatPipe,
    TierWalletComponent,
    AddTierComponent,
    ProductCatalogComponent,
    TaxTablesComponent,
    SupplierComponent,
    CommonPlansComponent,
    AdjudicationQueueComponent,
    AddDependentComponent,
    InvoiceModuleComponent,
    CreateSupplierComponent,
    ReceivablesComponent,
    PayableComponent,
    UpdateSupplierComponent,
    EditSupplierProductComponent
  ],
  imports: [
    CommonModule,
    BrowserModule,
    SignaturePadModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    BrowserAnimationsModule,
    RxReactiveFormsModule,
    PdfViewerModule,
    QuillModule.forRoot(),
    ToastrModule.forRoot({
      timeOut: 3000,
      positionClass: 'toast-top-right',
    }),
    NgMultiSelectDropDownModule.forRoot(),
    BsDatepickerModule.forRoot(),
    TimepickerModule.forRoot(),
    DataTablesModule,
    ClipboardModule,
    RecaptchaModule,
    RecaptchaFormsModule,
    SwiperModule,
    NgxEditorModule,
    CurrencyMaskModule,
    NgxDocViewerModule,
    StoreModule.forRoot(reducers),
    EffectsModule.forRoot([
      MemberEffects,
      CorporateEffects,
      AdvisorEffects,
      LanguageEffects,
      BrokerConfigEffects,
      CorporateSignupConfigEffects,
      BrokerFormConfigEffects,
      FormConfig2Effects
    ]),
    StoreDevtoolsModule.instrument({ }),
    
  ],
  exports: [PhoneMaskDirective, EnableDisableDirective],
  providers: [
    CacheService,
    ExcelService,
    AuthGuardService,
    { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true },
    SocketService,
    SocketMemberService,
    ApiService,
    ReportService,
    TravelCommissionsService,
    ReportScheduleService,
    PaymentService,
  ],
  // GlobalErrorHandlerService, { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true }, { provide: HTTP_INTERCEPTORS, useClass: GlobalErrorHandlerService, multi: true }
  // providers: [CacheService,ExcelService,AuthGuardService,{ provide: HTTP_INTERCEPTORS, useClass: CachingInterceptor, multi: true }],

  bootstrap: [AppComponent],
})
export class AppModule {}
